// extracted by mini-css-extract-plugin
export default {"root":"_3_4dP","dot":"_28eQM","current":"_23DOO"};